import fr from './fr.json';
import en from './en.json';
import es from './es.json';
import de from './de.json';
import pt from './pt.json';

export const SUPPORTED_LANGS = ['fr', 'en', 'es', 'de', 'pt'];
export const DEFAULT_LANG = 'en';

const translations = { fr, en, es, de, pt };

/**
 * Get initial language from URL, localStorage, or browser
 */
export function getInitialLanguage() {
  // 1. Check URL parameter
  const urlLang = new URLSearchParams(window.location.search).get('lang');
  if (urlLang && SUPPORTED_LANGS.includes(urlLang.toLowerCase())) {
    return urlLang.toLowerCase();
  }

  // 2. Check localStorage
  const storedLang = localStorage.getItem('trackvibes_lang');
  if (storedLang && SUPPORTED_LANGS.includes(storedLang)) {
    return storedLang;
  }

  // 3. Check browser language
  const browserLang = navigator.language?.slice(0, 2).toLowerCase();
  if (browserLang && SUPPORTED_LANGS.includes(browserLang)) {
    return browserLang;
  }

  // 4. Default to English
  return DEFAULT_LANG;
}

/**
 * Set language and persist it
 */
export function setLanguage(lang) {
  if (!SUPPORTED_LANGS.includes(lang)) return;
  
  // Save to localStorage
  localStorage.setItem('trackvibes_lang', lang);

  // Update URL without reload
  const url = new URL(window.location.href);
  url.searchParams.set('lang', lang);
  window.history.replaceState({}, '', url.toString());
}

/**
 * Translate a key
 */
export function t(key, lang) {
  const language = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  return translations[language]?.[key] || translations[DEFAULT_LANG]?.[key] || key;
}

/**
 * Get language label for display
 */
export function getLangLabel(lang) {
  const labels = {
    fr: 'FR',
    en: 'EN',
    es: 'ES',
    de: 'DE',
    pt: 'PT'
  };
  return labels[lang] || lang.toUpperCase();
}

/**
 * Build URL with language parameter preserved
 */
export function buildUrlWithLang(path, lang, extraParams = {}) {
  const url = new URL(path, window.location.origin);
  url.searchParams.set('lang', lang);
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, value);
    }
  });
  return url.pathname + url.search;
}
